import React, {Component} from "react";
import {Link} from "react-router";
import AppHeaderUser from "./AppHeaderUser.js";
import logo from "../img/logo.svg";
import ModalBugReport from "./ModalBugReport.js";
import ModalHelp from "./ModalHelp.js";
import BackButton from "./BackButton.js";
import Alerts from "../componentsBody/Alerts.js";
import ModalToken from "./ModalToken.js";

class AppHeader extends Component {
    render() {
        return (
            <nav className="app-header navbar navbar-light bg-faded">
                <div className="app-header-brand">
                    <BackButton/>
                    <Link to="/">
                        <img className="app-logo d-inline-block align-top" src={logo} alt=""/>
                        <span className="title">NUSarcast</span>
                    </Link>
                    <div className="app-header-user-wrapper ml-auto">
                        <AppHeaderUser />
                    </div>
                    <ModalBugReport />
                    <ModalHelp/>
                    <ModalToken/>
                </div>
                <Alerts />
            </nav>
        );
    }
}
export default AppHeader;


// WEBPACK FOOTER //
// ./src/componentsHeader/AppHeader.js